function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M20.073,48.667c-4.972-1.663-6.015-3.783-6.015-5.268c0-1.501,1.063-3.64,6.13-5.307l0.781,2.375  c-3.047,1.002-4.411,2.195-4.411,2.932c0,0.725,1.332,1.902,4.308,2.897L20.073,48.667z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M48.565,48.669l-0.781-2.375c3.047-1.002,4.412-2.195,4.412-2.932c0-0.725-1.332-1.902-4.309-2.897l0.793-2.371  c4.972,1.663,6.016,3.783,6.016,5.268C54.695,44.864,53.632,47.002,48.565,48.669z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M34.63,48.89c-5.806,0-11.684-1.784-11.684-5.194s5.878-5.194,11.684-5.194c5.807,0,11.685,1.784,11.685,5.194  S40.437,48.89,34.63,48.89z M34.63,41.002c-6.06,0-9.184,1.888-9.184,2.694s3.125,2.694,9.184,2.694s9.185-1.888,9.185-2.694  S40.69,41.002,34.63,41.002z"
});

var _ref5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M93.333,52.403H62.226v-8.708c0-6.389-11.863-11.208-27.595-11.208c-15.731,0-27.595,4.818-27.595,11.208v17.827   c0,6.389,11.863,11.206,27.595,11.206h58.703c0.69,0,1.25-0.56,1.25-1.25V53.653C94.583,52.963,94.023,52.403,93.333,52.403z    M52.372,52.403c3.128-1.04,5.65-2.359,7.354-3.889v3.889H52.372z M34.63,34.988c14.789,0,25.095,4.589,25.095,8.708   s-10.306,8.708-25.095,8.708c-14.789,0-25.095-4.589-25.095-8.708S19.842,34.988,34.63,34.988z M80.105,70.229h-4.449v-3.834h-2.5   v3.834h-3.686v-7.699h-2.5v7.699h-3.686v-3.834h-2.5v3.834h-3.685v-7.699h-2.5v7.699h-3.685v-3.834h-2.5v3.834H44.73v-7.699h-2.5   v7.699h-3.686v-3.834h-2.5v3.834H34.63c-0.771,0-1.525-0.016-2.271-0.039v-7.66h-2.5v7.532c-1.274-0.09-2.504-0.213-3.686-0.368   v-3.971h-2.5v3.587c-1.303-0.232-2.535-0.502-3.685-0.805v-8.037h-2.5v7.29c-1.396-0.473-2.628-0.997-3.685-1.553v-5.737h-2.5   v4.087c-1.148-0.99-1.769-2.024-1.769-3.032V48.514c4.278,3.843,13.662,6.389,25.095,6.389h45.475V70.229z M92.083,70.229h-9.478   V54.903h9.478V70.229z"
}), /*#__PURE__*/React.createElement("rect", {
  x: 85.946,
  y: 58.405,
  width: 2.5,
  height: 8.397
}));

var _ref6 = /*#__PURE__*/React.createElement("path", {
  stroke: "#000000",
  strokeWidth: 2.5,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  d: "  M39.647,53.472"
});

function SvgTapeMeasure(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100px",
    width: "100px",
    fill: "#000000",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    enableBackground: "new 0 0 100 100",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTapeMeasure);
export default __webpack_public_path__ + "static/media/tapeMeasure.6cffb98d.svg";
export { ForwardRef as ReactComponent };